export const FORM_FIELD_NAMES = {
  EMAIL: "email",
  PASSWORD: "password",
  CONFIRM_PASSWORD: "confirmPassword",
  FIRST_NAME: "firstName",
  LAST_NAME: "lastName",
  CLINIC_NAME: "clinicName",
  WEBSITE_LINK: "websiteLink",
  PHONE_NUMBER: "phoneNumber",
  TERMS: "terms",
};
